import { styled } from '@clickcease/cc-client-components-lib'

export const DomainTableStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  flexGrow: 1,
  height: '450px',
  overflow: 'auto',
})

export const DomainsFilterStyled = styled('div', {
  display: 'flex',
  position: 'relative',
  justifyContent: 'space-between',
  marginBottom: '15px',
})

export const DomainTableHeader = styled('div', {
  borderBottom: '1.5px solid $lightNeutral',
  height: '40px',
  lineHeight: '40px',
  display: 'flex',
  padding: '10px 0',
})

export const DomainTableHeaderText = styled('div', {
  ['button']: {
    padding: '0px',
  },

  ['svg']: {
    margin: '2px 0px 0px 6px',
  },
})

export const RowPart = styled('div', {
  color: '$mainTextColor',
  fontWeight: '$l',
  fontSize: '$md',
  lineHeight: '64px',
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  width: '100%',
  gap: '4px',
  ['button']: {
    marginTop: '0',
  },
})

export const PendingDomainsRowStyled = styled('div', {
  display: 'flex',
  height: '64px',
  borderBottom: '0.5px solid $lightNeutral',
  alignItems: 'center',
  position: 'relative',

  ['&:hover']: {
    background: '$codeBackground',
  },
  paddingLeft: '20px',
})

export const TabsWrapper = styled('div', { overflowY: 'auto', flexGrow: 1 })

export const LoaderWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
})
